import { type InsuranceCorporateIdentity } from "../types";

export function BmwLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_35_10117)">
        <path
          d="M256.525 64C150.199 64 64 150.199 64 256.525C64 362.85 150.199 449.049 256.525 449.049C362.85 449.049 449.049 362.85 449.049 256.525C449.049 150.199 362.85 64 256.525 64ZM436.53 256.525C436.53 355.934 355.945 436.53 256.525 436.53C157.104 436.53 76.5195 355.934 76.5195 256.525C76.5195 157.115 157.115 76.5195 256.525 76.5195C355.934 76.5195 436.53 157.115 436.53 256.525Z"
          fill="white"
        />
        <path
          d="M349.832 174.842C352.447 177.649 356.217 182.177 358.333 184.928L397.318 160.183C395.371 157.636 392.27 153.765 389.949 151.037L365.261 167.36L363.574 168.809L364.831 166.975L375.732 145.219L368.023 137.51L346.255 148.411L344.422 149.667L345.882 147.981L362.216 123.304C359.341 120.859 356.579 118.617 353.058 115.901L328.314 154.852C331.449 157.263 335.581 160.806 338.218 163.217L361.514 151.127L363.008 150.029L361.91 151.524L349.832 174.842Z"
          fill="white"
        />
        <path
          d="M261.369 125.477L272.021 101.615L272.7 99.4984L272.508 101.706L273.629 133.593C277.364 133.944 281.224 134.465 285.027 135.099L283.296 87.8731C277.975 87.2845 272.678 86.8657 267.38 86.6393L256.887 112.686L256.513 114.621L256.14 112.686L245.658 86.6393C240.36 86.8657 235.063 87.2845 229.742 87.8731L228.01 135.099C231.814 134.465 235.674 133.955 239.409 133.593L240.53 101.706L240.337 99.4984L241.017 101.615L251.668 125.477H261.369Z"
          fill="white"
        />
        <path
          d="M175.216 163.115C181.373 156.629 184.86 149.135 178.702 141.981C175.351 138.098 169.726 137.249 165.062 139.162L164.598 139.344L164.745 138.936C165.435 137.091 165.877 131.205 160.862 127.141C158.417 125.16 155.35 124.424 152.248 124.741C146.464 125.33 142.015 129.28 129.903 142.785C126.247 146.86 120.927 153.289 117.734 157.455L151.003 189.014C162.028 176.812 166.522 172.272 175.216 163.115ZM131.805 155.395C138.506 147.199 145.626 139.762 148.852 136.819C149.871 135.891 150.98 134.963 152.327 134.601C154.512 134.001 156.765 135.551 157.274 137.793C157.783 140.045 156.368 142.185 154.795 143.951C151.252 147.946 138.257 161.541 138.257 161.541L131.805 155.395ZM144.834 167.756C144.834 167.756 157.489 154.376 161.621 150.097C163.262 148.399 164.315 147.369 165.447 146.815C166.907 146.101 168.503 145.954 169.929 146.905C171.333 147.845 171.978 149.463 171.627 151.071C171.208 152.984 169.646 154.806 168.356 156.199C166.613 158.066 151.603 174.129 151.58 174.151L144.834 167.756Z"
          fill="white"
        />
        <path
          d="M370.695 256.525H256.525V142.355C319.62 142.355 370.695 193.429 370.695 256.525Z"
          fill="white"
        />
        <path
          d="M256.525 256.525V370.695C193.429 370.695 142.355 319.62 142.355 256.525H256.525Z"
          fill="white"
        />
        <path
          d="M256.525 142.355V256.525H142.355C142.355 193.429 193.429 142.355 256.525 142.355Z"
          fill="#0066B1"
        />
        <path
          d="M370.695 256.525C370.695 319.62 319.62 370.695 256.525 370.695V256.525H370.695Z"
          fill="#0066B1"
        />
      </g>
      <defs>
        <clipPath id="clip0_35_10117">
          <rect
            width="386"
            height="386"
            fill="white"
            transform="translate(64 64)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const BMW: InsuranceCorporateIdentity = {
  id: "bmw",
  name: "BMW BKK",
  logo: BmwLogo,
  backgroundColor: "#002A4B",
  textColor: "#FFFFFF",
  wildcard: "bmw",
  type: "statutory",
};
